import { styled } from '@linaria/react';

import { fonts, layout, semantic, space } from '../../theme/tokens';

export const ContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[5]};
  max-width: ${layout.narrowMaxWidth};
  margin: 0 auto;
`;

export const Paragraph = styled.p`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  color: ${semantic.text.primary};
  line-height: 1.6;
  margin: 0;
`;

export const ParagraphEmphasis = styled.p`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.bold};
  color: ${semantic.text.primary};
  line-height: 1.6;
  margin: 0;
`;

export const FormStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
`;

export const IntroStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[3]};
`;

export const ActionRow = styled.div`
  display: flex;
  padding-top: ${space[2]};
`;
